import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  @Input() customRoute?: string;
  @Input() label: string = 'Atrás';
  @Input() icon: string = 'pi pi-arrow-left';
  @Input() severity: string = 'secondary';
  @Input() size: string = 'normal'; // 'small', 'normal', 'large'
  @Input() position: string = 'inline'; // 'inline', 'top-left', 'top-right', 'bottom-left', 'bottom-right'
  @Input() showLabel: boolean = true;
  @Input() useHistory: boolean = true; // true = usar history.back(), false = usar router
  @Input() variant: string = 'button'; // 'button', 'link', 'icon-only'
  
  @Output() onBackClick = new EventEmitter<void>();

  constructor(
    private location: Location,
    private router: Router
  ) {}

  goBack(): void {
    // Emitir evento personalizado si hay listeners
    this.onBackClick.emit();

    if (this.customRoute) {
      // Navegar a ruta personalizada
      this.router.navigate([this.customRoute]);
    } else if (this.useHistory) {
      // Usar historial del navegador
      this.location.back();
    } else {
      // Navegar a la página anterior en el historial
      this.location.back();
    }
  }

  get buttonClass(): string {
    const sizeClass = this.size === 'small' ? 'p-button-sm' : 
                     this.size === 'large' ? 'p-button-lg' : '';
    
    const severityClass = this.severity ? `p-button-${this.severity}` : '';
    
    return `back-button ${sizeClass} ${severityClass}`.trim();
  }

  get containerClass(): string {
    if (this.position === 'inline') {
      return 'back-button-inline';
    }
    return `back-button-container back-button-${this.position}`;
  }

  get isInline(): boolean {
    return this.position === 'inline';
  }

  get isIconOnly(): boolean {
    return this.variant === 'icon-only';
  }

  get isLink(): boolean {
    return this.variant === 'link';
  }
} 